module.exports = {
	events: {
		privacyCloseButton: {
			type: 'click',
			selector: 'button',
			action: function(event){
				event.data.component.hideConfirmationOverlay();
			}
		}
	},
	methods: {
		hideConfirmationOverlay: function(){
			this.$.hide();
		},
		showConfirmationOverlay: function(){
			this.$.show();
		}
	}
};